var base = require('settings/teams/current-teams');

Vue.component('spark-current-teams', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/current-teams.js